import React from 'react';
import Box from '@mui/material/Box';

import Image from 'next/image';
import { getSteamIconUrl } from 'utils/outerImages';
import { BoxProps } from '@mui/material';

type SteamImageProps = {
  itemName: string;
  icon: string;
  boxProps?: BoxProps;
};

const SteamImage = ({ itemName, icon, ...boxProps }: SteamImageProps) => {
  return (
    <Box width='100%' height='65%' position='relative' {...boxProps}>
      <Image
        unoptimized
        loading='eager'
        key={`next-image-${itemName}`}
        src={getSteamIconUrl(icon)}
        alt={itemName}
        // layout='fill'
        // objectFit='contain'
        fill
        style={{
          objectFit: 'contain',
          width: '100%',
          height: '100%'
        }}
      />
    </Box>
  );
};

export default SteamImage;
